import { render } from "./nuevaPoliza.vue?vue&type=template&id=332e2a6c"
import script from "./nuevaPoliza.vue?vue&type=script&lang=js"
export * from "./nuevaPoliza.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__